import { createPivotTransformer } from './create-pivot-transformer';

const KGM3_PER_G_PER_CM3_OR_ML = 1000;

/** Pivot = kg/m³. */
export const DENSITY_PIVOT: Record<string, number> = {
  'kg/m3': 1,
  'g/cm3': KGM3_PER_G_PER_CM3_OR_ML,
  'g/ml': KGM3_PER_G_PER_CM3_OR_ML,
  'lb/ft3': 16.0185,
  'lb/gal': 119.826,
};

export const transformDensity = createPivotTransformer(DENSITY_PIVOT);
